import { createRouter, createWebHistory } from "vue-router";
import CodeBarScanner from "../views/CodeBarScanner.vue";
import Clients from "../views/Clients.vue";
import AuthRouter from "../auth/router"
import isAuthenticatedGuard from "../auth/router/auth-guard";


const routes = [
  {
    path: "/",
    name: "/",
    redirect: "/signin",
  },
  {
    path: "/codebarscanner/:clientId/:sucursalId/:clientName/:clientSucursal",
    name: "Scanner",
    component: CodeBarScanner,
    beforeEnter: [isAuthenticatedGuard, (to, from, next) => {
      const clientId = atob(to.params.clientId);
      // Verifica si clientId no es un número válido
      if (isNaN(parseInt(clientId))) {
        // Redirige a '/clients'
        // console.log("NO ES NUMERO", clientId)
        next('/clients');
      } else {
        // Continúa la navegación
        // console.log("SI ES NUMERO", clientId)
        if (parseInt(clientId) > 0)
          next();
        else
          next('/clients');
      }
    }],
    props: route => ({
      // clientId: !isNaN(parseInt(route.params.clientId)) ?
      // parseInt(route.params.clientId) > 0 ?
      clientId: route.params.clientId,
      sucursalId: route.params.sucursalId,
      clientName: route.params.clientName,
      clientSucursal: route.params.clientSucursal
      //   :
      //   '0'
      // :
      // '0'
    })
  },
  {
    path: "/clients",
    name: "Clients",
    component: Clients,
    beforeEnter: [isAuthenticatedGuard],
  },
  {
    path: "/signin",
    ...AuthRouter
  },
  { path: '/:pathMatch(.*)*', redirect: '/' }
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  linkActiveClass: "active",
});

export default router;
